"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("./styles"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _reactTransitionGroup = require("react-transition-group");

var _excluded = ["children", "className", "component", "color", "disabled", "onClick", "size", "type", "variant", "openInNewWindow", "startIcon", "endIcon", "title", "tooltipProps", "TooltipProps", "stopPropagation", "isLoading", "target"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Button = function Button(props) {
  var _otherProps$TouchRipp, _otherProps$TouchRipp2, _otherProps$TouchRipp3, _classNames;

  var children = props.children,
      className = props.className,
      component = props.component,
      color = props.color,
      disabled = props.disabled,
      onClick = props.onClick,
      size = props.size,
      type = props.type,
      variant = props.variant,
      openInNewWindow = props.openInNewWindow,
      startIcon = props.startIcon,
      endIcon = props.endIcon,
      title = props.title,
      tooltipProps = props.tooltipProps,
      TooltipProps = props.TooltipProps,
      stopPropagation = props.stopPropagation,
      isLoading = props.isLoading,
      target = props.target,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _styles.default)(props);
  var renderedOnClick = stopPropagation ? function (event) {
    event.stopPropagation();
    if (onClick) onClick(event);
  } : onClick;

  var touchRippleProps = _objectSpread(_objectSpread({}, otherProps.TouchRippleProps), {}, {
    classes: _objectSpread(_objectSpread({}, (_otherProps$TouchRipp = otherProps.TouchRippleProps) === null || _otherProps$TouchRipp === void 0 ? void 0 : _otherProps$TouchRipp.classes), {}, {
      root: (0, _classnames.default)("prmbl-touchRipple", (_otherProps$TouchRipp2 = otherProps.TouchRippleProps) === null || _otherProps$TouchRipp2 === void 0 ? void 0 : (_otherProps$TouchRipp3 = _otherProps$TouchRipp2.classes) === null || _otherProps$TouchRipp3 === void 0 ? void 0 : _otherProps$TouchRipp3.root)
    })
  });

  var loadingOverlay = /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
    in: true,
    timeout: 500
  }, /*#__PURE__*/_react.default.createElement(_Loader.default, {
    size: 24
  }));

  var shouldFixTooltip = (isLoading || disabled) && title;

  var buttonProps = _objectSpread(_objectSpread({
    color: color,
    // The tooltip doesn't work with a button component that is disabled, so render a span instead
    component: shouldFixTooltip ? "span" : component,
    className: (0, _classnames.default)("prmbl-button", className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "prmbl-button--".concat(color), color), (0, _defineProperty2.default)(_classNames, classes.sizeSmall, size === "small"), (0, _defineProperty2.default)(_classNames, classes.sizeLarge, size === "large"), (0, _defineProperty2.default)(_classNames, classes.iconButtonSizeSmall, size === "small" && type === "icon"), (0, _defineProperty2.default)(_classNames, classes.iconButtonSizeLarge, size === "large" && type === "icon"), (0, _defineProperty2.default)(_classNames, classes.button, type !== "icon" && type !== "fab"), (0, _defineProperty2.default)(_classNames, classes.iconButton, type === "icon"), (0, _defineProperty2.default)(_classNames, "prmbl-iconBtn", type === "icon"), (0, _defineProperty2.default)(_classNames, classes.fab, type === "fab"), (0, _defineProperty2.default)(_classNames, "prmbl-fabBtn", type === "fab"), (0, _defineProperty2.default)(_classNames, classes.tooltipFix, shouldFixTooltip), _classNames)),
    disabled: isLoading || disabled,
    target: openInNewWindow ? "_blank" : target,
    rel: "noopener noreferrer",
    onClick: isLoading || disabled ? undefined : renderedOnClick,
    size: size,
    variant: variant
  }, otherProps), {}, {
    TouchRippleProps: touchRippleProps
  });

  var buttonChildren = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && startIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.startIcon
  }, loadingOverlay), !isLoading && startIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.startIcon
  }, startIcon), isLoading && !startIcon && !endIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.mainLoadingButton
  }, loadingOverlay), children, isLoading && endIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.endIcon
  }, loadingOverlay), !isLoading && endIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.endIcon
  }, endIcon));

  var renderedButton = type === "icon" ? /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({}, buttonProps, {
    size: size === "large" ? undefined : size
  }), buttonChildren) : type === "fab" ? /*#__PURE__*/_react.default.createElement(_Fab.default, (0, _extends2.default)({}, buttonProps, {
    variant: variant === "text" || variant === "outlined" || variant === "contained" ? undefined : variant
  }), buttonChildren) : /*#__PURE__*/_react.default.createElement(_Button.default, buttonProps, buttonChildren);
  return title ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
    title: title,
    placement: "bottom"
  }, tooltipProps, TooltipProps), renderedButton) : renderedButton;
};

exports.Button = Button;
Button.defaultProps = {
  rel: "noopener noreferrer",
  variant: "contained",
  type: "default",
  TooltipProps: {
    placement: "bottom"
  }
};
var _default = Button;
exports.default = _default;